import { WarnIcon } from "../../dx-icons";

type Props = {
  /** 表示する注意書き本文 (例: "焚き火台なしのお部屋です") */
  notes: string;
};

/**
 * RoomType の `notes` を表示する注意書きバナー。
 * - 角丸の薄いサーフェスにアイコン + 太字のテキストを並べる
 * - TitleArea と SpecList の間に配置する想定
 */
export function NotesBanner({ notes }: Props) {
  return (
    <div className="px-[8px] pb-[8px]">
      <div className="bg-dx-surface-subtle inline-flex w-fit items-center gap-[8px] rounded-[8px] px-[16px] py-[10px]">
        <WarnIcon className="text-dx-text-default" />
        <p className="font-notojp text-dx-text-default text-[16px] leading-[1.6] font-semibold">
          {notes}
        </p>
      </div>
    </div>
  );
}
